/**
FUNCIONES DE AYUDA PARA LOS CAMPOS
*/

/**
 * quita o pone campo en lista
 * @param {string} campo 
 * @param {array} lista 
 * @returns true o false
 */
export function switchCampo(campo,lista){
	if (lista.includes(campo))
		lista.splice(lista.indexOf(campo),1)
	else
		lista.push(campo)
}


//hace una copia de un objeto
export function copy (obj) {
  let result;
  if (obj === null) {
    return obj;
  }
  if (obj instanceof Date) {
    result = new obj.constructor (obj.valueOf());
  } else if (typeof obj === 'object') {
    result = new obj.constructor ();
  } else {
    return obj;
  }
  for (let prop of Reflect.ownKeys (obj)) {
    result[ prop ] = copy (obj[ prop ]);
  }
  return result;
}